import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Observable, of, catchError, take, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { profileRouteNavigator } from '../helpers/profileRouteNavigator.helpers';
import { UserRole } from '../constants/keys.constant';
import { ProfileStepsCompleted } from '../constants/signUpStepper.const';

export const profileResolver: ResolveFn<any> = (route, state): Observable<any> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Fetch profile only if it's not already cached
  if (!authService.currentProfileDetails) {
    if (localStorage.getItem(environment.storageKey)) {
      return authService.getProfile().pipe(
        take(1),
        tap((profile) => {
          if (profile) {         
            authService.profileDetailsSubject.next(profile);
            if ((profile.role === UserRole.TUTOR || profile.role === UserRole.COUNSELOR) && profile.profileStepsCompleted === ProfileStepsCompleted.TutorCounsellorAvailabilityDone) {
              if (!state.url.includes('/tutor')) {
                router.navigate(['/tutor/dashboard']);
              }
            } else {
              profileRouteNavigator(profile, router, state.url);
            }
          }
        }),
        catchError((error) => {
          console.error('Error fetching profile:', error);
          return of(null);
        })
      );
    } 
    // else {
    //   router.navigate(['/auth/login']);
    //   return of(null);
    // }
  }

  // Return cached profile as an observable
  return authService.profileDetailsSubject.asObservable();
};
